<template>
    <main class="order order-flight">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="navsteps navstepts-flight">
                        <div class="navsteps__item">
                            <div class="number">1</div>
                            <div class="descr">Розрахунок</div>
                        </div>
                        <div class="navsteps__item">
                            <div class="number">2</div>
                            <div class="descr">Вибір СК</div>
                        </div>
                        <div class="navsteps__item active">
                            <div class="number">3</div>
                            <div class="descr">Оформлення</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="orders osago">
            <div class="container">
                <div class="row row-reverce">
                    <div class="col-lg-12">
                        <a href="javascript:void(0);" class="go-back" @click="$router.go(-1)">
                            Повернутися до оформлення
                        </a>
                        <div class="params-search">
                            <a class="params-search__toggler collapsed" data-toggle="collapse" data-target="#searchcollapse" aria-expanded="false" aria-controls="#searchcollapse">
                                <span>Параметри полісу</span>
                                <svg width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.2795 2.75059e-08L11 0.69496L5.5 6L-2.31891e-07 0.694961L0.7205 4.45343e-07L5.50275 4.61273L10.2795 2.75059e-08Z" fill="black"/>
                                </svg>
                            </a>
                            <div class="collapse" id="searchcollapse">
                                <div class="params-search__content">
                                    <div class="info">
                                        <b>{{ offerInfo.publicName }}</b>
                                        <div class="logo">
                                            <img v-if="offerInfo.company.logo" :src="offerInfo.company.logo" alt="logo">
                                            <img v-else src="images/aboutUs-insurance_icon.svg" alt="logo">
                                        </div>
                                    </div>
                                    <div class="params">
                                        <div class="params-item">
                                            <p>Компанія:</p>
                                            <span>{{ offerInfo.companyNamePublic }}</span>
                                        </div>
                                        <div class="params-item">
                                            <p>Транспортний засіб:</p>
                                            <span>{{ searchInfo.carType.name}}</span>
                                        </div>
                                        <div class="params-item">
                                            <p>Покриття:</p>
                                            <span>{{ searchInfo.country.name}}</span>
                                        </div>
                                        <div class="params-item">
                                            <p>Тип користувача:</p>
                                            <span>{{ searchInfo.userType.value}}</span>
                                        </div>
                                        <div class="params-item">
                                            <p>Початок дії:</p>
                                            <span>{{ searchInfo.startDate}}</span>
                                        </div>
                                        <div class="params-item">
                                            <p>Період:</p>
                                            <span>{{searchInfo.periodOption.name}}</span>
                                        </div>
                                        <div class="params-item">
                                            <p>Вартість:</p>
                                            <span>{{offerInfo.price}} грн</span>
                                        </div>

                                    </div>

                                    <div class="param-price">
                                        <p>Загальна вартість:</p>
                                        <div class="result__price">
                                          <div v-if="hasDiscountCalc" class="old"
                                               data-placement="bottom" data-toggle="tooltip"
                                               title="Знижка надається безпосередньо за наш рахунок від ціни, що надається страховою компанією. Ми забезпечуємо найнижчу ціну на ринку. Вартість поліса вказана з урахуванням знижки.">
                                            <span>{{ fullInfo.price || (fullInfo.offer ? fullInfo.offer.price : 0) }} <span>грн</span></span>
                                            <b v-if="dynamicDiscountedSumCalc > 0">-{{ dynamicDiscountedSumCalc }} грн</b>
                                            <b v-else >-{{ discountPercentCalc }}%</b>
                                          </div>
                                          <div data-toggle="tooltip" data-html="true"  data-id="details-discount-tooltip" :title="showPriceDetails" v-if="hasDiscountCalc" :class="['price','value','red']">
                                            {{ showFinishPrice }} <span>грн</span>
                                          </div>
                                          <div v-else :class="['value']" data-original-title="">
                                            {{ showFinishPrice }} <span>грн</span>
                                          </div>
                                        </div>
                                    </div>

                                  <div class="col-lg-3  param-price">

                                  </div>


                                </div>
                            </div>
                        </div>
                        <div class="row flex-lg-row-reverse" style="position: relative;">
                            <div class="finnaly-column col-lg-3">
                                <div class="sticky-wrapp">
                                    <AutocivilPromo></AutocivilPromo>
                                </div>
                            </div>

                            <form class="finnaly-form col-lg-9" >
                                <div class="row">
                                    <div class="col-12">
                                        <h2>Оформления страхування</h2>
                                    </div>
                                    <div class="col-12">
                                        <h3>
                                            Перевірте дані та перейдіть до оплати:
                                        </h3>
                                    </div>
                                    <div ref="ticketsection" :class="['row col-12 finnaly-container', {'disabled-container' : !createTicketInfo}]">
                                        <button v-if="enableEditform" class="edit-btn" type="button" @click="createTicketInfo = !createTicketInfo">
                                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M21.5796 4.546L17.6662 0.612662C17.4076 0.355372 17.0577 0.210937 16.6929 0.210938C16.3281 0.210938 15.9781 0.355372 15.7196 0.612662L1.84622 14.466L0.57955 19.9327C0.535854 20.1325 0.537352 20.3396 0.583934 20.5388C0.630516 20.7379 0.721005 20.9242 0.848792 21.0839C0.976578 21.2437 1.13843 21.3728 1.32253 21.462C1.50663 21.5512 1.70833 21.5981 1.91288 21.5993C2.0082 21.609 2.10424 21.609 2.19955 21.5993L7.72622 20.3327L21.5796 6.49266C21.8368 6.23407 21.9813 5.88412 21.9813 5.51933C21.9813 5.15454 21.8368 4.80459 21.5796 4.546ZM7.05955 19.1327L1.87955 20.2193L3.05955 15.1393L13.4396 4.79933L17.4396 8.79933L7.05955 19.1327ZM18.3329 7.83266L14.3329 3.83266L16.6529 1.526L20.5862 5.526L18.3329 7.83266Z" fill="#007BBB"/>
                                            </svg>
                                        </button>
                                        <button v-if="enableEditform" class="save-btn" type="button" @click="saveChange()">
                                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M21.5796 4.546L17.6662 0.612662C17.4076 0.355372 17.0577 0.210937 16.6929 0.210938C16.3281 0.210938 15.9781 0.355372 15.7196 0.612662L1.84622 14.466L0.57955 19.9327C0.535854 20.1325 0.537352 20.3396 0.583934 20.5388C0.630516 20.7379 0.721005 20.9242 0.848792 21.0839C0.976578 21.2437 1.13843 21.3728 1.32253 21.462C1.50663 21.5512 1.70833 21.5981 1.91288 21.5993C2.0082 21.609 2.10424 21.609 2.19955 21.5993L7.72622 20.3327L21.5796 6.49266C21.8368 6.23407 21.9813 5.88412 21.9813 5.51933C21.9813 5.15454 21.8368 4.80459 21.5796 4.546ZM7.05955 19.1327L1.87955 20.2193L3.05955 15.1393L13.4396 4.79933L17.4396 8.79933L7.05955 19.1327ZM18.3329 7.83266L14.3329 3.83266L16.6529 1.526L20.5862 5.526L18.3329 7.83266Z" fill="#fff"/>
                                            </svg>
                                            <span>Зберегти зміни</span>
                                        </button>
                                        <div class="col-12">
                                            <div class="info-container_heading">Дані зеленой карти</div>
                                        </div>

                                        <div class="col-6">
                                            <div class="info-block">
                                                <b>Номерний знак</b>
                                                <p>{{ car.number }}</p>
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="info-block">
                                                <b>Марка</b>
                                                <p>{{ car.brand }}</p>
                                            </div>
                                        </div>

                                        <div class="col-6">
                                            <div class="info-block">
                                                <b>Модель</b>
                                                <p>{{ car.model }}</p>
                                            </div>
                                        </div>

                                        <div class="col-6">
                                            <div class="info-block">
                                                <b>Рік випуску авто</b>
                                                <p>{{ car.year }}</p>
                                            </div>
                                        </div>

                                        <div class="col-6">
                                            <div class="info-block">
                                                <b>VIN номер авто</b>
                                                <p>{{ car.vin }}</p>
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="info-block">
                                                <b>Маса без навантаження, кг</b>
                                                <p>{{ car.ownWeight }}</p>
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="info-block">
                                                <b>Повна маса, кг</b>
                                                <p>{{ car.totalWeight }}</p>
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="info-block">
                                                <b>Кількість місць для сидіння, включно з місцем водія</b>
                                                <p>{{ car.nSeating }}</p>
                                            </div>
                                        </div>
                                        <div class="col-6" v-if="car.autoCategory !== 'B5'">
                                            <div class="info-block">
                                                <b>Об’єм двигуна</b>
                                                <p>{{ car.engineSize }}</p>
                                            </div>
                                        </div>
                                        <div class="col-6" v-else>
                                            <div class="info-block">
                                                <b>Потужність (для електромобілів), кВт</b>
                                                <p>{{ car.kvt }}</p>
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="info-block">
                                                <b>Місто реєстрації</b>
                                                <p>{{ car.city.name_full_name_ua ? car.city.name_full_name_ua : car.city.name }}</p>
                                            </div>
                                        </div>
                                       <div class="col-6">
                                           <div class="info-block">
                                               <b>Початок дії</b>
                                               <button type="button" v-if="! confirmContractStatus" @click="changestartOrderDate()" v-b-tooltip="'Змінити дату початку'" class="history-order__form-btn edit-limit">
                                                   <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                       <path d="M15.045 5.1023C15.423 4.71657 15.631 4.2043 15.631 3.65937C15.631 3.11444 15.423 2.60217 15.045 2.21644L13.459 0.59799C13.081 0.212256 12.579 0 12.045 0C11.511 0 11.009 0.212256 10.632 0.596969L0 11.4128V15.9182H4.413L15.045 5.1023ZM12.045 2.04092L13.632 3.65835L12.042 5.27476L10.456 3.65733L12.045 2.04092ZM2 13.8772V12.2598L9.04 5.09822L10.626 6.71667L3.587 13.8772H2ZM0 17.9591H16V20H0V17.9591Z" fill="#007BBB"/>
                                                   </svg>
                                               </button>

                                               <date-picker v-model="startOrderDate" :config="optionsStartOrderDate" :class="['form-control','date-input']" placeholder="Введіть дату" :disabled="startOrderDateDisabled" ></date-picker>
                                           </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-12">
                                        <hr>
                                    </div>
                                    <div :class="['row col-12 finnaly-container', {'disabled-container' : !createUserInfo}]">
                                        <button v-if="enableEditform" class="edit-btn" type="button" @click="createUserInfo = !createUserInfo">
                                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M21.5796 4.546L17.6662 0.612662C17.4076 0.355372 17.0577 0.210937 16.6929 0.210938C16.3281 0.210938 15.9781 0.355372 15.7196 0.612662L1.84622 14.466L0.57955 19.9327C0.535854 20.1325 0.537352 20.3396 0.583934 20.5388C0.630516 20.7379 0.721005 20.9242 0.848792 21.0839C0.976578 21.2437 1.13843 21.3728 1.32253 21.462C1.50663 21.5512 1.70833 21.5981 1.91288 21.5993C2.0082 21.609 2.10424 21.609 2.19955 21.5993L7.72622 20.3327L21.5796 6.49266C21.8368 6.23407 21.9813 5.88412 21.9813 5.51933C21.9813 5.15454 21.8368 4.80459 21.5796 4.546ZM7.05955 19.1327L1.87955 20.2193L3.05955 15.1393L13.4396 4.79933L17.4396 8.79933L7.05955 19.1327ZM18.3329 7.83266L14.3329 3.83266L16.6529 1.526L20.5862 5.526L18.3329 7.83266Z" fill="#007BBB"/>
                                            </svg>
                                        </button>
                                        <button v-if="enableEditform" class="save-btn" type="button" @click="saveChange()">
                                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M21.5796 4.546L17.6662 0.612662C17.4076 0.355372 17.0577 0.210937 16.6929 0.210938C16.3281 0.210938 15.9781 0.355372 15.7196 0.612662L1.84622 14.466L0.57955 19.9327C0.535854 20.1325 0.537352 20.3396 0.583934 20.5388C0.630516 20.7379 0.721005 20.9242 0.848792 21.0839C0.976578 21.2437 1.13843 21.3728 1.32253 21.462C1.50663 21.5512 1.70833 21.5981 1.91288 21.5993C2.0082 21.609 2.10424 21.609 2.19955 21.5993L7.72622 20.3327L21.5796 6.49266C21.8368 6.23407 21.9813 5.88412 21.9813 5.51933C21.9813 5.15454 21.8368 4.80459 21.5796 4.546ZM7.05955 19.1327L1.87955 20.2193L3.05955 15.1393L13.4396 4.79933L17.4396 8.79933L7.05955 19.1327ZM18.3329 7.83266L14.3329 3.83266L16.6529 1.526L20.5862 5.526L18.3329 7.83266Z" fill="#fff"/>
                                            </svg>
                                            <span>Зберегти зміни</span>
                                        </button>
                                        <div class="col-12">
                                            <div class="info-container_heading">Дані страхувальника</div>
                                        </div>

                                        <div class="col-6" v-if="searchInfo.userType.id == 2">
                                            <div class="info-block">
                                                <b>ЄДРПОУ компанії</b>
                                                <p>{{ order.info.erdpyCode }}</p>
                                            </div>
                                        </div>
                                        <div class="col-6" v-if="searchInfo.userType.id == 2">
                                            <div class="info-block">
                                                <b>Назва компанії</b>
                                                <p>{{ order.info.name }}</p>
                                            </div>
                                        </div>
                                        <div v-else-if="searchInfo.userType.id == 1" class="col-12 row passport-block">
                                            <div class="col-6">
                                                <div class="info-block">
                                                    <b>Ім’я</b>
                                                    <p>{{ order.info.name }}</p>
                                                </div>
                                            </div>
                                            <div class="col-6">
                                                <div class="info-block">
                                                    <b>Прізвище</b>
                                                    <p>{{ order.info.surname }}</p>
                                                </div>
                                            </div>
                                            <div class="col-6">
                                                <div class="info-block">
                                                    <b>Дата народження</b>
                                                    <p>{{ order.info.dateBirth }}</p>
                                                </div>
                                            </div>
                                            <div class="col-6">
                                                <div class="info-block">
                                                    <b>ІПН</b>
                                                    <p>{{ order.info.identificationCode }}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="info-block">
                                                <b>Номер телефону</b>
                                                <p>{{ order.info.phone }}</p>
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="info-block">
                                                <b>Email</b>
                                                <p>{{ order.info.mail }}</p>
                                            </div>
                                        </div>
                                        <div class="passport-row row" v-if ="searchInfo.userType.id != 2 && order.info.withoutDocuments == 0">
                                            <div v-if="order.info.documentation.type != 8" class="col-lg-6">
                                                <div class="info-block">
                                                    <b>Серія документа</b>
                                                    <p>{{ order.info.documentation.serial }}</p>
                                                </div>
                                            </div>
                                            <div class="col-lg-6">
                                                <div class="info-block">
                                                    <b>Номер паспорта</b>
                                                    <p>{{ order.info.documentation.number }}</p>
                                                </div>
                                            </div>
                                            <div v-if="order.info.documentation.type != 8" class="col-lg-6">
                                                <div class="info-block">
                                                    <b>Ким виданий</b>
                                                    <p>{{ order.info.documentation.issuedBy }}</p>
                                                </div>
                                            </div>
                                            <div v-if="order.info.documentation.type != 8" class="col-lg-6">
                                                <div class="info-block">
                                                    <b>Дата видачі</b>
                                                    <p>{{ order.info.documentation.dateOfIssue }}</p>
                                                </div>
                                            </div>
                                            <div v-if="order.info.documentation.endDateOfIssue" class="col-lg-6">
                                                <div class="info-block">
                                                    <b>Закінчення дії</b>
                                                    <p>{{ order.info.documentation.endDateOfIssue }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-12">
                                        <hr/>
                                    </div>
                                    <div class="col-lg-3 price-block">
                                        <div class="price-label">Загальна вартість</div>
                                    </div>
                                    <div class="col-lg-3 price-block param-price">
                                      <div class="result__price">
                                        <div v-if="hasDiscountCalc" class="old"
                                             data-placement="bottom" data-toggle="tooltip"
                                             title="Знижка надається безпосередньо за наш рахунок від ціни, що надається страховою компанією. Ми забезпечуємо найнижчу ціну на ринку. Вартість поліса вказана з урахуванням знижки.">
                                          <span>{{ fullInfo.price || (fullInfo.offer ? fullInfo.offer.price : 0) }} <span>грн</span></span>
                                          <b v-if="dynamicDiscountedSumCalc > 0">-{{ dynamicDiscountedSumCalc }} грн</b>
                                          <b v-else >-{{ discountPercentCalc }}%</b>
                                        </div>
                                        <div data-toggle="tooltip" data-html="true"  data-id="details-discount-tooltip" :title="showPriceDetails" v-if="hasDiscountCalc" :class="['price','value','red']">
                                          {{ showFinishPrice }} <span>грн</span>
                                        </div>
                                        <div v-else :class="['value']" data-original-title="">
                                          {{ showFinishPrice }} <span>грн</span>
                                        </div>
                                      </div>
                                    </div>
                                    <use-bonus
                                        v-if="!$store.getters.USER.organizationId"
                                        class="col-lg-6"
                                        @show-earnings="showEarnings = $event"
                                        @use-bonuses="useBonuses = $event"
                                    ></use-bonus>
                                </div>
                                <earnings v-show="earnings && showEarnings"
                                          :earnings="earnings"
                                          :discount-details="fullInfo.discountDetails"
                                          :use-bonuses="useBonuses"
                                          :data-is-load-earning="dataIsLoadEarning"
                                          v-model="bonusSystemValue"
                                ></earnings>
                                <div class="row">

                                    <div class="col-lg-12">
                                        <hr/>
                                    </div>

                                    <div v-if="confirmContractStatus" class="col-lg-12 text-center position-relative">
                                        <button
                                            type="button"
                                            v-on:click="showDraft()"
                                            class="btn btn-dark">
                                            Переглянути пропозицію
                                        </button>
                                    </div>
                                    <div v-if="! confirmContractStatus" class="col-lg-6 text-center position-relative">
                                        <router-link to="/greencard-steps">
                                            <button
                                                type="button"
                                                class="btn btn-warning">
                                                Редагувати дані
                                            </button>
                                        </router-link>
                                    </div>

                                    <div class="col-lg-12">
                                        <hr/>
                                    </div>

                                  <dynamic-discount-block
                                      v-if="!$store.getters.USER.organizationId && !(discountPercentCalc > 0) && !isApiOrLandingUser"
                                      :data-confirm-contract-status="confirmContractStatus"
                                      :data-set-discounted-price-status="setDiscountedPriceStatus"
                                      :data-full-info="fullInfo"
                                      :data-otp-flags="otpFlags"
                                      :data-loading="dataIsLoadEarning"
                                      @update:tooltip="updateTooltip"
                                      @update:priceChanged="discountPriceChanged"
                                  ></dynamic-discount-block>
                                  <otp-block
                                      ref="otpBlock"
                                      :data-otp-flags="otpFlags"
                                      :data-agreement="true"
                                      :data-confirm-contract-status="confirmContractStatus"
                                      @formSendOtp="formSendOtp"
                                      @otpCheck="otpCheck"
                                      @otpChanged="otpChanged"
                                  ></otp-block>

                                    <div v-if="confirmContractStatus && setDiscountedPriceStatus && otpFlags.otpStatus && otpFlags.confirmOtpStatus" class="col-lg-12 text-center position-relative">
                                        <button
                                            v-if="orderPaid"
                                            type="button"
                                            class="btn btn-success"
                                        >
                                            Сплачено
                                        </button>
                                        <button
                                            v-else
                                            type="button"
                                            :disabled="dataIsLoadEarning"
                                            v-loading="dataIsLoadEarning"
                                            @click="showAllOrderPaymentWays()"
                                            class="btn btn-warning">
                                            Сплатити поліс
                                        </button>
                                    </div>
                                    <div class="col-lg-12" v-if="! confirmContractStatus">
                                      <div class="form-check">
                                        <input v-model="personalCheck" type="checkbox" id="personal" class="form-check-input">
                                        <label for="personal" :class="['form-check-label', { error : !personalCheck && submitCheck}]">Згоден з обробкою персональних даних. Дані будуть передані в страхову компанію для формування поліса</label>
                                      </div>
                                    </div>
                                    <div v-if="! confirmContractStatus" class="col-12 text-center position-relative">
                                        <button
                                            :disabled="otpFlags.confirmOtpStatus || !setDiscountedPriceStatus"
                                            v-loading="loadingOrder"
                                            type="button"
                                            v-on:click="makeContract('make')"
                                            class="btn btn-blue">Заявити</button>
                                    </div>

                                    <div v-if="showFileInputReceipt" class="col-12 text-center">
                                        <file-input :http-request="uploadReceipt" @remove-file="receiptLoaded = false">Прикріпити файл квитанції</file-input>
                                    </div>
                                    <div class="col-12 text-center position-relative">
                                        <button
                                            type="button"
                                            :disabled="!canConfirmContract"
                                            v-on:click="confirmContract()"
                                            :class="['btn', (canConfirmContract ? 'btn-blue' : 'btn-dark-grey')]"
                                        >
                                            Оформити
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <modalDocument></modalDocument>
        <animationModal></animationModal>
        <modal-response-status :data-response="dataResponse" :data-product-type="dataProductType"></modal-response-status>
        <modal-response-confirm-status :data-response="dataResponse" :data-product-type="dataProductType"></modal-response-confirm-status>
        <modalSuccess @showload="downloadContract()"></modalSuccess>
        <choice-otp-sending-direction ref="ChoiceOtpSendingDirection" @sendOtpApi="sendOtpApi"></choice-otp-sending-direction>
        <modal-declared-success ref="modalDeclaredSuccess"></modal-declared-success>
        <modal-get-invoice-order ref="modalGetInvoiceOrder" @invoice-created="loadOrder"></modal-get-invoice-order>
        <modal-get-instant-loan ref="modalGetInstantLoan"></modal-get-instant-loan>
        <modal-get-mono-pay-parts ref="showModalGetMonoPayParts"></modal-get-mono-pay-parts>
        <modal-get-all-payment-ways
            ref="modalGetAllPaymentWays"
            @showModalGetInvoiceOrder="showModalGetInvoiceOrder"
            @showModalGetInstantLoan="showModalGetInstantLoan"
            @showModalGetMonoPayParts="showModalGetMonoPayParts"
            @showModalGetInvoiceLegal="showModalGetInvoiceLegal"
            :is-legal-type="isLegalType"
            :company-id="companyId"
            :program-name="programName"
        >
        </modal-get-all-payment-ways>
        <modal-company-client-black-list ref="showModalCompanyClientBlackList"></modal-company-client-black-list>
        <modal-disable-create-orders ref="showModalDisableCreateOrders"></modal-disable-create-orders>
        <fin-monitoring :visible.sync="showFinMonitoringModal" @confirm="confirmFinMonitoring"></fin-monitoring>
    </main>
</template>

<script>
import Multiselect from 'vue-multiselect';
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';
import { changeOrderGreenCard } from '@/api/changeOrderGreenCard';
import { contractGreenCard } from '@/api/contractGreenCard';
import { list as greenCardCompaniesList } from '@/api/greenCardInsuranceCompany';
import { checkPayment, uploadReceipt } from '@/api/invoice';
import { downloadOrder, getPaymentInvoice,  showOrder } from '@/api/order';
import { orderGreenCard } from '@/api/orderGreenCard';
import Earnings from '@/components/app/bonusSystem/Earnings.vue';
import UseBonus from '@/components/app/bonusSystem/UseBonus.vue';
import dynamicDiscountBlock from '@/components/app/dynamic-discount/dynamicDiscountBlock.vue';
import citySearch from '@/components/app/forms/CitySearch.vue';
import countrySearch from '@/components/app/forms/CountrySearch';
import FileInput from '@/components/app/forms/FileInput.vue';
import modalDocument from '@/components/app/modals/modal-flight-document';
import modalSuccess from '@/components/app/modals/modal-green-card-success';
import animationModal from '@/components/app/modals/modal-payAnimation';
import modalResponseConfirmStatus from '@/components/app/modals/modal-response-confirm-status.vue';
import modalResponseStatus from '@/components/app/modals/modal-response-status.vue';
import { ChoiceOtpSendingDirection,
  DeclaredSuccess as ModalDeclaredSuccess,
  DisableCreateOrders as ModalDisableCreateOrders,
  GetAllPaymentWays as ModalGetAllPaymentWays,
  GetInstantLoan as ModalGetInstantLoan,
  GetPaymentLink as ModalGetInvoiceOrder,
  GetMonoPayParts as ModalGetMonoPayParts,
  CompanyClientBlackList as ModalCompanyClientBlackList
} from '@/components/app/modals/order';
import FinMonitoring from '@/components/app/modals/order/FinMonitoring.vue';
import otpBlock from '@/components/app/otp/otpBlock.vue';
import { otpFunc } from '@/mixin';
import order from '@/mixin/order';
import AutocivilPromo from '@/views/flight/components/AutocivilPromo.vue';
import confirmContractProcessingBroadcastMixin from "@/mixin/ConfirmContractProcessingBroadcastMixin";

export default {
  components: {
    FileInput,
    dynamicDiscountBlock,
    FinMonitoring,
    UseBonus,
    Earnings,
    otpBlock,
    Multiselect,
    VueTypeaheadBootstrap,
    AutocivilPromo,
    modalDocument,
    citySearch,
    countrySearch,
    modalSuccess,
    animationModal,
    ModalDeclaredSuccess,
    ModalGetAllPaymentWays,
    ModalGetInvoiceOrder,
    ModalGetInstantLoan,
    ModalGetMonoPayParts,
    ChoiceOtpSendingDirection,
    modalResponseStatus,
    modalResponseConfirmStatus,
    ModalDisableCreateOrders,
    ModalCompanyClientBlackList
  },
  mixins: [otpFunc, order, confirmContractProcessingBroadcastMixin],
  data: function () {
    return {
      checkPaidInterval: null,
      showFinMonitoringModal: false,
      isAgreeFinMonitoring: false,
      loadingOrder: false,
      otpFlags:{
        otpPass: '', // ОТР - код
        additionalOtps: {}, // Додаткові ОТП коди
        otpStatus: true, // true - Включить отправку ОТР - кода
        confirmOtpStatus: false, // true - OTP код проверен успешно
        sentOtpPass: false, // true - OTP код был отправлен mail/viber/sms
        sendingOtpError: false, // true - при отправке ОТР кода произошла ошибка
        submitOtpCheck: false, // true - была нажата кнопка отправки ОТР кода на проверку
        otpCodeValidate: true, // статус проверки ОТР кода true - прошел проверку, false - код неверный
        pandingOtpSending: false, // флаг для отображения прелоадера при отправке ОТР кода
        pandingOtpCheck: false, // флаг для отображения прелоадера при отправке ОТР кода на проверку
      },

      earnings: 0,
      useBonuses: false,
      dataIsLoadEarning: false,
      showEarnings: false,
      bonusSystemValue: 0,
      startOrderDateDisabled: true,
      startOrderDate: null,
      optionsStartOrderDate: {
        format: 'DD.MM.YYYY',
        useCurrent: false,
        minDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()+1),
        maxDate: new Date(new Date().getFullYear(), new Date().getMonth(), (new Date().getDate()+this.$store.getters.GREENCARD_INFO_OFFER.dateFromMax)),
        locale: 'uk',
        icons: {
          previous: 'icon arrow-point-to-left',
          next: 'icon arrow-point-to-right',
        },
      },
      enableEditform: false,
      LetterMaskError: false,
      showPopularCountries:false,
      confirmContractStatus: false,
      setDiscountedPriceStatus: false,
      carBrands:[],
      carModels:[],
      contractId:false,
      orderId: false,
      companyId: null,
      programName: null,
      dataResponse: null,
      dataProductType: 'greencard',
      car: {
        vin: null,
        year: null,
        brand: null,
        model: null,
        number: null,
        city: {
          cdb_mtibu_code: null,
          id: null,
          kaotuu: '',
          name_full_name_ru: '',
          name_full_name_ua: '',
          name_ru: '',
          name_ua: '',
          type_population: null,
          zone: null,
        },
        withoutVin: false
      },
      styleSel: {
        border: 'none',
      },
      searchInfo: {
        'carType': {
          'name': '',
          'group': '',
          'external_id': '',
          'engines': [
          ],
          'types': []
        },
        'userType': {
          'value': 'Фізична особа',
          'id': 1,
          'key': 'natural'
        },
        'country': {
          'id': 0,
          'name': '',
          'name_ru': ''
        },
        'startDate': '',
        'periodOption': {
          'id': null,
          'name': ''
        }
      },
      showOtp: false,
      elSelectStatus:true,
      createTicketInfo: false,
      createUserInfo: false,
      submitCheck: false,
      personalCheck: false,
      isLegalType: false,
      cityFrom: null,
      carType:{},
      carTypes: [{ 'name':'Легкові автомобілі','group':'CAR', 'external_id':'A',
        'engines':[{ 'name':'до 1600 см3','value':'A1' },
          { 'name':'1601-2000 см3','value':'A2' },
          { 'name':'2001-3000 см3','value':'A3' },
          { 'name':'более 3001 см3','value':'A4' }], 'types':[] },
      { 'name':'Автобус','group':'BUS', 'external_id':'E', 'engines':[],
        'types':[{ 'name':'менше 20 осіб','value':'E1' },
          { 'name':'більше 20 осіб','value':'E2' }] },
      { 'name':'Вантажні автомобілі','group':'CARGO', 'external_id':'C', 'engines':[],
        'types':[{ 'name':'менше 2-х тонн','value':'C1' },
          { 'name':'більше 2-х тонн','value':'C2' }] },
      { 'name':'Причіп, Трейлер','group':'TRAILER','engine':null, 'external_id':'F', 'engines':[],
        'types':[{ 'name':'До вантажного авто','value':'F' },
          { 'name':'До легкового авто','value':'F' }] },
      { 'name':'Мотоцикли та моторолери','group':'BIKE', 'external_id':'B',
        'engines':[{ 'name':'300 см3 або менше','value':'B1' },
          { 'name':'більше 300 см3','value':'B2' }], 'types':[] }
      ],
      periodOptions: [
        { 'id': 15, 'name' : '15 д' },
        { 'id': 1, 'name' : '1 міс' },
        { 'id': 2, 'name' : '2 міс' },
        { 'id': 3, 'name' : '3 міс' },
        { 'id': 4, 'name' : '4 міс' },
        { 'id': 5, 'name' : '5 міс' },
        { 'id': 6, 'name' : '6 міс' },
        { 'id': 7, 'name' : '7 міс' },
        { 'id': 8, 'name' : '8 міс' },
        { 'id': 9, 'name' : '9 міс' },
        { 'id': 10, 'name' : '10 міс' },
        { 'id': 11, 'name' : '11 міс' },
        { 'id': 12, 'name' : '12 міс' },
      ],
      optionsStartDate: {
        format: 'DD.MM.YYYY',
        useCurrent: false,
        minDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
        locale: 'uk',
        icons: {
          previous: 'icon arrow-point-to-left',
          next: 'icon arrow-point-to-right',
          time: 'fa fa-clock-o',
          date: 'fa fa-calendar',
        },
      },
      order:{
        startDate: null,
        country: null,
        periodOption:null,
        info: {
          identificationCode: null,
          withoutIdentificationCode:false,
          withoutDocuments:false,
          name: null,
          surname: null,
          dateBirth: null,
          phone: null,
          mail: null,
          city: null,
          street: null,
          house: null,
          apartment: null,
          internationalPassport: null,
          documentType: null,
          passportSerial: null,
          passportNumber: null,
          passportCompany: null,
          passportDate: null,
          documentation: {
            //TODO текущее значение нобходимо будет брать с словаря(api)
            type: 'DOCUMENT_PASSPORT',
            serial: null,
            number: null,
            issuedBy: null,
            dateOfIssue: null,
            endDateOfIssue: null,
            dateOfIssueError: false,
          },
        }
      },
      //TODO need refactoring order united standard
      tempOrderData: null,
    };
  },
  watch:{
    'otpFlags': {
      handler: function(newVal) {
        let offerInfo = Object.assign({}, this.offerInfo);
        offerInfo.otpFlags = newVal;
        this.updateStore(offerInfo);
      },
      deep: true,
    },
  },
  async created() {
    await this.$store.dispatch('initGreenCardInfoOrder');
    await this.$store.dispatch('initGreenCardFullInfoOrder');

    this.fetchSearchInfo(this.$store.getters.GREENCARD_SEARCH_PARAMS);

    this.fetchOrder(this.$store.getters.GREENCARD_FULL_ORDER);
    this.fetchInfoCar(this.$store.getters.GREENCARD_INFO_CAR);
    this.fetchUserInfo(this.$store.getters.GREENCARD_INFO_USER);
    this.fetchOtpFlags(this.fullInfo.otpFlags);
    this.isLegalType = (this.order.userType.id == 2);
    this.confirmContractStatus = this.fullInfo?.confirmContractStatus ?? false;
    this.companyId = this.offerInfo?.companyId || this.offerInfo?.company?.id;
    this.programName = this.offerInfo?.programName;

    if (this.$store.getters.USER.organizationId || this.discountPercentCalc > 0 || this.isApiOrLandingUser) {
      this.setDiscountedPriceStatus = true;
    }

    if(this.confirmContractStatus){
      this.setDiscountedPriceStatus = true;
      this.agreement = true;
    }
    this.startOrderDate = moment(this.$store.getters.GREENCARD_INFO_OFFER.startDate,'DD/MM/YYYY');

    showOrder(this.order.orderId).then(response => {
      this.tempOrderData = response.data.data;
      this.checkOtpEntered();

      this.checkPaidInterval = setInterval(() => {
        if (this.$route.query.invoice) {
          this.checkPaid(this.$route.query.invoice);
        } else if (this.tempOrderData.payments) {
          const payments = this.tempOrderData.payments.map(item => {
            if (item.invoice.type_id === 2) {
              return item.invoice;
            }
          });

          payments.forEach(item => {
            this.checkPaid(item.id);
          });
        }
      }, 2000);
    });
  },

  computed: {
    isApiOrLandingUser() {
      const typeId = Number(this.$store.getters.USER.type_id);
      return [2, 4, 5].includes(typeId);
    },
    hasDiscountCalc() {
      const fi = this.fullInfo || {};
      const offer = fi.offer || {};
      return (fi.dynamicDiscountedSum > 0) || (fi.discountPrice > 0) || (offer.dynamicDiscountedSum > 0) || (offer.discountPrice > 0);
    },
    dynamicDiscountedSumCalc() {
      const fi = this.fullInfo || {};
      const offer = fi.offer || {};
      return fi.dynamicDiscountedSum || offer.dynamicDiscountedSum || 0;
    },
    discountPercentCalc() {
      const fi = this.fullInfo || {};
      const offer = fi.offer || {};
      if (fi.discountPercent) return fi.discountPercent;
      if (offer.discountPercent) return offer.discountPercent;
      
      const price = offer.price || fi.price;
      const discountPrice = offer.discountPrice || fi.discountPrice;
      
      if (price && discountPrice) {
        return Math.round(((price - discountPrice) / price) * 100);
      }
      return 0;
    },
    offerInfo(){
      return this.$store.getters.GREENCARD_INFO_OFFER;
    },
    fullInfo() {
      return this.$store.getters.GREENCARD_FULL_ORDER;
    },
    getParentUserId() {
      return this.$store.getters.USER_INFO.parentId ?? this.$store.getters.USER.id;
    },
    showFinishPrice(){
      return this.showPrice();
    },
    showPriceDetails(){
      const price = this.fullInfo?.offer?.price || this.fullInfo.price || 0;
      const discountPriceSource = this.fullInfo?.offer?.discountPrice || this.fullInfo.discountPrice || 0;
      const dynamicDiscountPrice = this.fullInfo?.offer?.dynamicDiscountPrice || this.fullInfo.dynamicDiscountPrice || 0;
      const dynamicDiscountedSumSource = this.fullInfo?.offer?.dynamicDiscountedSum || this.fullInfo.dynamicDiscountedSum || 0;

      let isDynamic = dynamicDiscountPrice > 0;
      let discountPrice = isDynamic ? dynamicDiscountPrice : discountPriceSource;
      if (isDynamic && typeof this.showDynamicDiscountPrice === 'function') {
        discountPrice = this.showDynamicDiscountPrice();
      }
      
      let discountedSum = isDynamic ? dynamicDiscountedSumSource : null;
      if (!isDynamic && discountPriceSource > 0 && price > 0) {
        discountedSum = (price - discountPriceSource).toFixed(2);
      }
      
      let earnings = this.fullInfo?.offer?.earnings || this.fullInfo.earnings;
      let dynamicEarnings = isDynamic ? (this.fullInfo?.offer?.dynamicEarnings || this.fullInfo.dynamicEarnings) : null;
      if (isDynamic && typeof this.showDynamicEarnings === 'function') {
        dynamicEarnings = this.showDynamicEarnings();
      }

      if (discountPrice && !isNaN(discountPrice)) discountPrice = Number(discountPrice).toFixed(2);
      if (discountedSum && !isNaN(discountedSum)) discountedSum = Number(discountedSum).toFixed(2);

      let text =
                '<div class=\'details-price-tooltip\'> ' +
                '<div class=\'details-price\'>' +
                '      <div class="tooltip-row">' +
                '        <span class="tooltip-label">Знижка:</span>' +
                '        <span class="tooltip-value">'+ (discountedSum || ' - ') + ' грн</span>' +
                '      </div>' +
                '      <div class="tooltip-row">' +
                '        <span class="tooltip-label">Ціна зі знижкою:</span>' +
                '        <span class="tooltip-value">' + (discountPrice || ' - ')+ ' грн</span>' +
                '      </div>' +
                '      <div class="tooltip-row">' +
                '        <span class="tooltip-label">Загальний заробіток:</span>' +
                '        <span class="tooltip-value">' + (earnings || ' - ') + ' грн</span>' +
                '      </div>' ;
      if(isDynamic){
        text +=  '<div class="tooltip-row">' +
                    '        <span class="tooltip-label">Заробіток зі знижкою:</span>' +
                    '        <span class="tooltip-value">' + (dynamicEarnings || ' - ') + ' грн</span>' +
                    '      </div>' ;
      }
      text += '</div> ';
      '</div>';
      return text;
    },
    //TODO order mixin
    showFileInputReceipt() {
      return !this.$store.getters.USER.organizationId && this.otpFlags.confirmOtpStatus && this.tempOrderData && this.tempOrderData.payments && this.tempOrderData.payments.length && this.tempOrderData.payments.some(item => item.invoice.type_id === 8);
    },
    orderPaid() {
      if (this.tempOrderData && this.tempOrderData.payments && this.tempOrderData.payments.length) {
        const sumPay = this.tempOrderData.payments.reduce((sumPay, item) => {
          if (item.invoice.status_id === 2) {
            return sumPay + parseFloat(item.invoice.amount);
          }
          return sumPay;
        }, 0,);
        if (sumPay >= this.tempOrderData.allPrice) {
          this.dropInterval();

          return true;
        }
      }

      return false;
    },
    //TODO end
  },

  methods: {
    loadOrder() {
      showOrder(this.order.orderId).then(response => {
        this.tempOrderData = response.data.data;
      });
    },
    dropInterval() {
      clearInterval(this.checkPaidInterval);
      this.checkPaidInterval = null;
    },
    updateStore(offerInfo){
      this.$store.commit('SET_GREENCARD_INFO_OFFER', offerInfo);
      this.$store.commit('SET_GREENCARD_FULL_ORDER', offerInfo.orderId);
    },
    showPrice() {
      const fi = this.fullInfo || {};
      const offer = fi.offer || {};
      const price = fi.dynamicDiscountPrice || offer.dynamicDiscountPrice || fi.discountPrice || offer.discountPrice || fi.price || offer.price;
      return Number(price).toFixed(2);
    },
    discountPriceChanged() {
      if (this.$store.getters.USER.organizationId || this.discountPercentCalc > 0 || this.isApiOrLandingUser) {
        this.setDiscountedPriceStatus = true;
      } else {
        this.setDiscountedPriceStatus = this.confirmContractStatus || false;
      }
    },
    updateTooltip(data) {
      this.dataIsLoadEarning = true;

      let offerInfo = Object.assign({}, this.offerInfo);

      let discountDetails = {
        dynamicDiscountPrice: 0,
        dynamicDiscountPercent: 0,
        dynamicDiscountedSum: 0,
        dynamicEarnings: 0
      };
      if (parseFloat(data.discountPrice) > 0 && parseFloat(data.price) > parseFloat(data.discountPrice)) {
        discountDetails.dynamicDiscountPrice = parseFloat(data.discountPrice).toFixed(2);
        discountDetails.dynamicDiscountPercent = parseFloat(data.discountPercent).toFixed(2);
        discountDetails.dynamicDiscountedSum = parseFloat(data.discountedSum).toFixed(2);
        discountDetails.dynamicEarnings = parseFloat(data.earnings).toFixed(2);
        discountDetails.earnings = parseFloat(offerInfo.earnings).toFixed(2);
      }
      offerInfo.discountDetails = discountDetails;
      offerInfo = { ...offerInfo,...discountDetails };
      this.updateStore(offerInfo);
      this.loadingOrder = true;
      this.$nextTick(() => {
        $('[data-id="details-discount-tooltip"]').tooltip('dispose').tooltip();
      });
      this.dataIsLoadEarning = false;
      let params = {
        type: 'next',
        statusId: 1,
      };

      orderGreenCard(this.offerInfo, this.searchInfo, this.info, this.car, this.orderId, params).then(() => {
        this.setDiscountedPriceStatus = true;
        this.loadingOrder = false;
      });
    },
    //TODO order mixin
    uploadReceipt(event) {
      const payment = this.tempOrderData.payments.find(item => item.invoice.type_id === 8);

      if (payment) {
        uploadReceipt(payment.invoice.id, event.file).then(response => {
          if (response.data.status === 'success') {
            this.receiptLoaded = true;
          }
        });
      }
    },
    checkPaid(invoiceId) {
      checkPayment(invoiceId).then(response => {
        if (response?.data?.data?.invoice?.status_id === 2) {
          showOrder(this.tempOrderData.id).then(response => this.tempOrderData = response.data.data);
        }
      });
    },
    checkOtpEntered() {
      if (this.tempOrderData.otpHistory?.date_otp_entered) {
        this.agreement = true;
        this.otpFlags.confirmOtpStatus = true;
        this.otpFlags.sentOtpPass = true;
        this.$refs.otpBlock.$data.otpPass = this.tempOrderData.otpHistory.code;
      }
    },
    //TODO end
    changestartOrderDate(){
      if(this.confirmContractStatus)
        this.startOrderDateDisabled = true;
      this.startOrderDateDisabled = false;
    },
    showAllOrderPaymentWays() {
      const earnings = this.fullInfo.dynamicDiscountedSum > 0 ? this.fullInfo.dynamicEarnings : this.earnings;
      this.$refs.modalGetAllPaymentWays.open(this.order.orderId, this.showFinishPrice, earnings);
    },
    showModalGetInvoiceOrder(orderData, provider) {
      this.$refs.modalGetInvoiceOrder.open(this.orderId, this.showFinishPrice, provider);
    },
    showModalGetInstantLoan() {
      this.$refs.modalGetInstantLoan.open(this.orderId, this.showFinishPrice);
    },
    showModalGetMonoPayParts() {
      this.$refs.showModalGetMonoPayParts.open(this.orderId, this.showFinishPrice, []);
    },
    showModalGetInvoiceLegal: async function() {
      const price = this.showFinishPrice;

      let orderWithData = await showOrder(this.orderId);
      const mtsbuCode = orderWithData.data.data?.mtsbuCode ?? null;

      let invoiceLegalData = {
        company: this.order.info?.name,
        code: this.order.info?.erdpyCode ?? '',
        price: price,
        mtsbuCode: mtsbuCode,
      };

      let response = await getPaymentInvoice(this.order.orderId, price, 'legal-entity-insurance');
      const tempResponse = await showOrder(this.orderId);
      this.tempOrderData = tempResponse.data.data;

      let params = new URLSearchParams(invoiceLegalData).toString();
      let url = `/api/orders/show-invoice-legal/${this.getParentUserId}/${this.orderId}?${params}`;

      const link = document.createElement('a');
      link.href = url;
      link.download = ''; // або залиш пусти — Safari сам запропонує зберегти
      // link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      //downloadInvoiceLegal(this.getParentUserId, this.order.orderId, params)
    },
    formatDate(date) { // функция сделана для Apple, формат датапикера меняется...
      const formats = ['DD.MM.YYYY', 'DD-MM-YYYY', 'ddd MMM DD YYYY HH:mm:ss ZZ'];
      const momentDate = moment(date, formats, true);
      if (momentDate.isValid()) {
        return momentDate.format('DD-MM-YYYY');
      } else {
        // Если дата не может быть распознана, возвращаем исходное значение
        return date;
      }
    },
    confirmFinMonitoring() {
      setTimeout(() => {
        this.isAgreeFinMonitoring = true;
        this.makeContract('make');
      }, 1500);
    },
    checkFinMonitoring() {
      if (this.order.price >= 40000 && !this.isAgreeFinMonitoring) {
        this.showFinMonitoringModal = true;

        return true;
      }

      return false;
    },
    makeContract(type) {
      if (this.checkFinMonitoring()) {
        return;
      }

      this.submitCheck = true;
      if(this.personalCheck){
        this.startOrderDateDisabled = true;
        this.showAnimateModal();
        this.offerInfo.startDate = this.formatDate(this.startOrderDate);
        this.searchInfo.startDate = this.offerInfo.startDate;
        let offerInfo = this.offerInfo;
        let searchInfo = this.searchInfo;
        let userInfo = this.info;
        let carInfo = this.car;

        let params = {
          type: type,
          statusId: null,
        };

        this.$store.commit('SET_GREENCARD_INFO_USER', userInfo);
        this.$store.commit('SET_GREENCARD_INFO_CAR', carInfo);

        orderGreenCard(offerInfo, searchInfo, userInfo, carInfo, this.order.orderId, params, this.bonusSystemValue).then((response) => {
          $('#modalPayAnimation').modal('hide');
          if (response && response.data.count >= 1) {
            this.offerInfo.confirmContractStatus = true;
            this.offerInfo.invoiceLink = response.data.data[0]?.mtsbuLink;

            this.confirmContractStatus = true;
            this.orderId = response.data.data[0].id;
            this.$store.commit('SET_GREENCARD_FULL_ORDER', response.data.data[0].id);
            let mtsbuLink = response.data.data[0]?.mtsbuLink;
            this.invoiceLink = response.data.data[0]?.mtsbuLink;
            if (mtsbuLink) {
              this.$refs.modalDeclaredSuccess.open(mtsbuLink);
            } else {
              this.$alert('Зелена картка заявлена', '', 'error');
            }
            return true;
          }else if(response && response.data.message){
            this.dataResponse = response.data.message;
            $('#modalResponseStatus').modal('show');
          }
        }).catch(error => {
          $('#modalPayAnimation').modal('hide');
          if (error?.response?.data?.data?.orderId && error?.response?.data?.data?.orderId[0].includes('недостатньо коштів')) {
            this.$alert(error?.response?.data?.data?.orderId[0], '', 'error');
          } else if (error?.response?.data?.message) {
            if(error.response.data.message == 'Заблокований для ордеров'){
              this.$refs.showModalDisableCreateOrders.open();
            } else if (error.response.data.message == 'CompanyClientBlackList block') {
              this.$refs.showModalCompanyClientBlackList.open();
            } else{
              this.$alert(error.response.data.message, '', 'error');
            }
          } else {
            this.$alert('Зелена картка не підписана', '', 'error');
          }
        });
      }
    },
    confirmContract() {
      this.showAnimateModal();

      let data = {
        orderId: this.orderId,
        bonusSystemValue: this.bonusSystemValue
      };
      if (this.offerInfo.prolongOrderId) {
        data.prolongOrderId = this.offerInfo.prolongOrderId;
      }

      contractGreenCard(data).then((response) => {
        $('#modalPayAnimation').modal('hide');
        if (response?.data?.status === 'success' && !!response.data.data[0].contractId) {
          $('#modalFlightSuccess').modal('show');
          this.$store.commit('SET_GREENCARD_CONTRACT_ID', response.data.data[0].contractId);
          this.contractId = response.data.data[0].contractId;
          //this.$router.push({name: "history"});
          return true;
        }

        this.$alert('Зелена Картка не оформлена', '', 'error');
      }).catch(error => {
        if (error?.response?.data.data.length > 0 && error?.response?.data?.data?.orderId[0].includes('недостатньо коштів')) {
          this.$alert(error?.response?.data?.data?.orderId[0], '', 'error');
        }else if(error?.response?.data?.message){
          //console.log('error?.response?.data?.message',error?.response?.data?.message);
          this.dataResponse = error?.response?.data?.message;
          $('#modalResponseConfirmStatus').modal('show');
        } else {
          this.$alert('Зелена Картка не оформлена', '', 'error');
        }

        $('#modalPayAnimation').modal('hide');
      });

    },
    saveChange(){
      this.submitCheck = true;
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }
      changeOrderGreenCard(this.order).then(() => {
        this.$store.commit('SET_GREENCARD_CHANGE_ORDER', this.order);
        this.$router.go();
      }).catch(() => {
        this.$alert('Щось пішло не так. Перевірте заповнені поля.');
      });
    },
    fetchOrder(data){
      if(data){
        this.order = data;
        this.orderId = this.order.orderId;
      }
    },
    fetchOtpFlags(data){
      if(data){
        this.otpFlags = data;
      }
    },
    fetchSearchInfo(data){
      if(data){
        this.searchInfo = data;
      }
    },
    fetchOfferInfo(data){
      if(data){
        this.offerInfo = data;
      }
    },
    fetchInfoCar(data){
      if(data){
        this.car = data;
      }
    },
    fetchUserInfo(data){
      if(data){
        this.info = data;
      }
    },
    downloadContract() {
      $('#modalFlightSuccess').modal('hide');
      downloadOrder(this.$store.getters.USER.id, this.order.orderId);
    },
    showDraft() {
      downloadOrder(this.$store.getters.USER.id, this.order.orderId);
    },
    citySelect(data) {
      this.car.city = data.city;
    },
    countrySelect(data) {
      this.country = data.country;
    },
    showAnimateModal() {
      $('#modalPayAnimation').modal({
        backdrop: 'static',
        keyboard: true,
        show: true,
      });

      let width = 1;
      let id = setInterval(frame, 200);

      /**
       *
       */
      function frame() {
        if (width >= 99) {
          clearInterval(id);
          // i = 0;
        } else {
          width += 2;
          $('.results_anime_percent-text').text(`${width}%`);
          $('.results_anime_line-scale').css({ width: `${width}%` });
        }
      }
    },
    isInvalid(val) {
      return val == null && this.submitForm;
    },
    async retryRequest(fn, attempts = 3) {
      for (let i = 0; i < attempts; i++) {
        try {
          return await fn();
        } catch (e) {
          if (i === attempts - 1) throw e;
          await new Promise(r => setTimeout(r, 500 * (i + 1)));
        }
      }
    },
    recalculateEarningsFallback() {
      if (!Number(this.earnings)) {
        this.earnings = this.offerInfo?.earnings || this.fullInfo?.earnings || this.order?.earnings || 0;
      }
    },
    async recalculateEarnings() {
      this.dataIsLoadEarning = true;
      let params = this.$store.state.GreenCardInsuranceCompanyStore.requestData;
      try {
        const response = await this.retryRequest(() => greenCardCompaniesList(
          encodeURIComponent(JSON.stringify(params.car)),
          params.country.id,
          params.carType.external_id,
          params.car?.number || params?.carNumber,
          params.userType.id,
          params.startDate,
          params.periodOption.id,
          this.offerInfo.moduleId
        ));
        if (response?.data?.status === 'success') {
          let offer = this.$_.find(response?.data?.data, (item) => {
            return item.company.id === this.order.company.id;
          });
          if (offer) {
            this.earnings = offer.earnings;
          } else {
            this.recalculateEarningsFallback();
          }
        } else {
          this.recalculateEarningsFallback();
        }
      } catch (e) {
        console.error('recalculateEarnings failed', e);
        this.recalculateEarningsFallback();
      } finally {
        this.dataIsLoadEarning = false;
      }
    },
  },
  mounted() {
    this.recalculateEarnings();
  },
  beforeDestroy() {
    this.dropInterval();
    if (this.offerInfo.confirmContractStatus) {
      this.$router.replace('/history');
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.osago {
    overflow-x: unset;
}

.param-price{
/*  margin-left: auto;*/
  width: 316px;
  padding: 0;
  background: none;
  box-shadow: none;
}
</style>
